import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';


const AnimatedSearch = () => {
  const [query, setQuery] = useState('');
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  // "/" focuses the search from anywhere except another text field.
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      const el = document.activeElement;
      if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || el.isContentEditable)) return;
      e.preventDefault();
      inputRef.current?.focus();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query.trim())}`);
    }
    setQuery('');
  };

  return (
    <form
      ref={containerRef}
      onSubmit={handleSubmit}
      className="flex items-center justify-center w-full"
    >
      <div
        data-tour="global-search"
        className="group relative flex items-center flex-grow min-w-0 md:flex-grow-0 md:w-72 md:focus-within:w-96 transition-[width] duration-300 ease-out"
      >
        <button
          type="submit"
          className="absolute left-3 flex items-center text-gray-400 group-focus-within:text-cloudza-600 hover:text-cloudza-600 transition-colors focus-ring rounded-lg"
          aria-label="Search"
        >
          <FaSearch className="w-3.5 h-3.5" />
        </button>
        <input
          ref={inputRef}
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Escape') e.currentTarget.blur(); }}
          placeholder="Search calls, agents, campaigns…"
          className="topbar-search text-sm text-gray-900 placeholder-gray-400 w-full pl-9 pr-10 outline-none"
        />
        {!query && (
          <span
            className="topbar-kbd absolute right-3 hidden md:inline-flex group-focus-within:opacity-0 transition-opacity"
            aria-hidden="true"
          >
            /
          </span>
        )}
      </div>
    </form>
  );
};

export default AnimatedSearch;
